<template>
    <div>
        <h3>2026 CRDC Shanghai Outing FAQ</h3>
        <div class="van-ellipsis" style="font-size:12px">(工会会根据实际情况不时更新FAQ内容)</div>
        <br />
        <van-cell-group v-for="record in qaData" :key="record">
            <van-cell :value="'Q:' + record.Q" style="background-color: #a8e87a;" />
            <van-cell :value="'A:' + record.A" />
        </van-cell-group>
    </div>
</template>
<script>
import { Cell, CellGroup } from 'vant';

export default {
    name: 'Outing',
    data () {
        return {
            qaData: [
                {
                    Q: "每张携程任我行卡使用期限是多久？",
                    A: "每张携程卡从激活之日起使用期限为3年，激活日从工会财务人员确认收货日(今年上半年的收货日：2026/1/20)开始计算"
                },
                {
                    Q: "工会每年outing人数的cut off date是什么时候？",
                    A: "CRDC上海工会每年outing有2次cut off date，上半年为1/5，下半年为六月底，在这2个cut off date之前入职的同事都可以领取2026年度工会的outing福利；每年的cut off date时间会略有调整，具体以工会公布的信息为准；"
                },
                {
                    Q: "每位员工该去哪里领取当年度的携程任我行卡呢？",
                    A: "去所对应的工会小组长这边领取，如果不清楚所对应的工会小组长是谁，可以去工会微信平台上查询；"
                },
                {
                    Q: "携程任我行卡如果遗失了怎么办？",
                    A: "不记名携程任我行卡几乎等同于现金，不可挂失，遗失不补。请大家尽早领用到个人账户，以免丢失造成不必要的损失。"
                },
                {
                    Q: "携程任我行卡使用范围？",
                    A: "携程礼品卡可支持机票（仅限任我行）、预付酒店、旅游度假、邮轮、签证、用车、预付门票等大部分产品订单（注：部分特殊产品因受国家政策影响或法律另有限制性规定，不支持礼品卡支付使用），不同类型礼品卡具体使用范围以携程旅行网公示为准。"
                },
                {
                    Q: "携程任我行卡订购产品时，如需退定产品，需要注意点什么呢？",
                    A: "使用携程礼品卡支付订单费用，在订单变更的政策及规范方面和其他支付方式相同。持卡人使用携程礼品卡购买产品发生退货的，经核实后退还礼品卡到支付所使用的携程会员账户-礼品卡余额内，退款周期一般为2个工作日内。"
                },
                {
                    Q: "携程的客服电话？",
                    A: "使用中遇到任何问题，请联系携程客服，电话10106666"
                }
            ]
        };
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Outing.vue